cv.ShareView = Marionette.LayoutView.extend({
  className: "modal-share",

  template: cv.Templates["share/view"],

  events: {
    "click .share-email-toggle": "toggleShareEmail",
    "click .share-email-back": "toggleShareEmail",
    "click .show-share": "backToShareEmail",
    "click .share-email-preview": function (e) {
      // Disable any clicks in here
      e.preventDefault();
    },
    "submit .share-email-container-form": "sendShareEmail",
    "keyup #share-email-message": "updateMessage",
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.title = "";
    this.description = "";
    this.image = "";
    this.appeal = "";
    this.appeal_html = "";
    this.window = null;

    console.log("ShareView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  onAttach: function () {
    // Define default share functionality
    var url = this.options.url;

    if (!_.isUndefined(url)) {
      this.$("a").data("url", url);
      this.$(".share-url").text(url);
      this.$(".share-url").attr("data-clipboard-text", url);
      this.$(".copy-share-url").attr("data-clipboard-text", url);
    } else {
      this.$("a").data("url", top.location);
      this.$(".share-url").text(top.location);
      this.$(".share-url").attr("data-clipboard-text", top.location);
      this.$(".copy-share-url").attr("data-clipboard-text", top.location);
    }

    var clipboard = new Clipboard(".share-url, .copy-share-url");
    clipboard.on("success", function (e) {
      console.info("action:", e.action);
      console.info("text:", e.text);
      console.info("trigger:", e.trigger);

      vent.trigger("notif:success", "Link copied to clipboard.");

      e.clearSelection();
    });

    // Define e-mail share functionality
    if (!_.isUndefined(cv.user)) {
      // Grab the share data if we are logged in
      this.getShareData();

      // Show the toggle button instead of the mailto button for logged in user
      this.$(".share-email-toggle").css({ display: "flex" });
    } else {
      // Show mailto button instead of toggle button for unauthenticated viewers
      this.$(".share-email").css({ display: "flex" });
    }
  },

  onDestroy: function () {},

  toggleShareEmail: function (e) {
    e.preventDefault();

    // Hide/Show the share container and email container
    this.$(".share-email-container").toggleClass("hide");
    this.$(".share-container").toggleClass("hide");
  },

  sendShareEmail: function (e) {
    e.preventDefault();

    var recipients = this.$(".share-email-recipients").val();
    var message = this.$(".share-email-message").val();

    // Reset the email/recipient callback
    this.$("#share-email-recipients-callback").html("");

    // Check for valid recipient emails
    if (recipients === "") {
      // recipients empty
      this.$("#share-email-recipients-callback").html("Required");
      this.$("#share-email-recipients").addClass("error");

      return false;
    }
    var error_text = cv.validateEmails(recipients);
    if (error_text != "") {
      // recipients invalid
      this.$("#share-email-recipients-callback").html(error_text);
      this.$("#share-email-recipients").addClass("error");

      return false;
    }

    // Hide share container
    this.$("#share-email-preview-text").html("");
    this.$(".share-email-container-form")[0].reset();
    this.$(".share-email-container").toggleClass("hide");

    // Hide the send button, Show "sending..."
    this.$(".share-email-send").addClass("button-disabled").text("Sending...");

    $.ajax({
      url: cv.api_path + "/messages/share",
      dataType: "json",
      data: {
        recipients: recipients,
        body: message,
        url: encodeURIComponent(this.options.url),
      },
      type: "post",
      complete: _.bind(function (data) {
        // Show the send button, hide "sending..."
        this.$(".share-email-send").removeClass("button-disabled").text("Share");
      }, this),
      success: _.bind(function (data) {
        // Returns a 200 response with the success message
        this.$(".share-email-response h3").text("Your message was sent!");
        this.$(".share-email-response").toggleClass("hide");
        this.$(".share-email-response .fa-check-circle").show();
        this.$(".share-email-response .fa-times").hide();
        this.$(".share-email-response .show-share").hide();
      }, this),
      error: _.bind(function (data) {
        // Returns a 404 response or something if we need to throttle or reject bad actors
        // show error message
        this.$(".share-email-response h3").text("Something went wrong, please try again later.");
        this.$(".share-email-response").toggleClass("hide");
        this.$(".share-email-response .fa-check-circle").hide();
        this.$(".share-email-response .fa-times").show();
      }, this),
    });
  },

  backToShareEmail: function (e) {
    e.preventDefault();

    // reset the response
    this.$(".share-email-response h3").text("").removeClass("success").removeClass("fail");

    // hide the response, show the email form
    this.$(".share-email-container").removeClass("hide");
    this.$(".share-email-response").addClass("hide");
  },

  updateMessage: function (e) {
    e.preventDefault();

    var previewText = this.$(e.target).val();

    if (previewText != "") {
      this.$(".fundraiser__message").text('"' + previewText + '"');
    } else {
      this.$(".fundraiser__message").text("");
    }
  },

  getShareData: function () {
    $.ajax({
      url: cv.api_path + "/campaigns/share_info?url=" + encodeURIComponent(this.options.url),
      dataType: "json",
      type: "get",
      success: _.bind(function (data) {
        this.title = data.title;
        this.description = data.description;
        this.image = data.image;
        this.appeal = data.appeal;
        this.appeal_html = data.appeal_html;

        // Get cropped image for email preview
        var logo_img = cv.photo({
          photo_path: cv.campaign.get("organization.brand_logo_path"),
          transforms: {
            fit: "clip",
            w: 150,
          },
          url_only: true,
        });

        var fundraiser_img = cv.photo({
          photo_path: cv.user.get("photo_path"),
          transforms: {
            fit: "crop",
            w: 80,
            h: 80,
          },
          url_only: true,
        });

        // Render preview
        this.$(".share-email-preview").html(
          cv.Templates["global/email_templates/share_page"]({
            logo_photo_path: logo_img,
            share_photo_path: this.image,
            has_share_image: this.image.includes("transparent_pixel.png") ? false : true,
            fundraiser_photo_path: fundraiser_img,
            fundraiser: cv.user.get("first_name") + " " + cv.user.get("last_name"),
            url: this.options.url,
            title: this.title,
            appeal: this.appeal_html,
          })
        );

        // Render custom branding
        if (cv.campaign.get("organization.enable_branding") == 1) {
          // Show the logo
          this.$(".org-logo").show();

          // Set the accent color
          this.$(".share-email-preview .content").css(
            "border-top",
            "3px solid " + cv.campaign.get("organization.brand_color")
          );
        }
      }, this),
    });
  },
});
